import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const AboutPage = () => {
  // Refs for GSAP animations
  const titleRef = useRef(null);
  const visionRef = useRef(null);
  const approachRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Initial animations
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    tl.fromTo(
      titleRef.current,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1 }
    );

    // Vision and Approach sections animations
    gsap.fromTo(
      [visionRef.current, approachRef.current],
      {
        y: 30,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        stagger: 0.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: visionRef.current,
          start: "top 80%",
        },
      }
    );
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <h1 ref={titleRef} className="text-4xl font-bold mb-16">
        About Us
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div ref={visionRef}>
          <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
          <p className="text-lg mb-4">
            We are dedicated to creating innovative and sustainable
            architectural designs that transform spaces and enhance lives.
          </p>
        </div>
        <div ref={approachRef}>
          <h2 className="text-2xl font-semibold mb-4">Our Approach</h2>
          <p className="text-lg mb-4">
            We combine modern design principles with sustainable practices to
            create buildings that are both beautiful and environmentally
            responsible.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
